import { Observable, Observer } from "rxjs";
import { HTTP_METHOD } from "../../constants/http";
import { AxiosSubscriber } from "../AxiosSubscriber";
import { INotificationStatusModel } from "../../models";
import { PromisifiableBase } from "../Base/PromisifiableBase";

export class NotificationStatusesService extends PromisifiableBase {
  get url(): string {
    return "/NotificationStatuses";
  }

  public select = (): Observable<INotificationStatusModel[]> =>
    new Observable(
      (observer: Observer<INotificationStatusModel[]>) =>
        new AxiosSubscriber(observer, {
          method: HTTP_METHOD.GET,
          url: `${this.url}/Select`,
        })
    );
}
